"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _getallrewards = /*#__PURE__*/ _interop_require_default(require("../utils/get-all-rewards"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getEligibleRewards = (0, _getallrewards.default)('isEligible');
var _default = getEligibleRewards;
